<template>
  <div class="vendorcontainer">
    <!--<div class="overlayLoad"></div>-->
    <v-content>
      <v-container fluid>
        <v-flex xs3>
          <div class="relative">
            <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
            <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
            <!--<v-text-field v-if="search != ''" label="Search" solo single-line v-model="search"></v-text-field><br />-->
          </div>
        </v-flex>
        <v-data-table :headers="headers" :search="search" :items="vendorList" class="elevation-1" :rows-per-page-items="[20,40,60,80,100]">
          <template slot="items" slot-scope="props">
            <td width="30%" >{{ props.item.name }}</td>
            <td width="25%">{{ props.item.description }}</td>
            <!--<td width="40%"  v-html="fncShowRanges(props.item.ranges)">{{ fncShowRanges(props.item.ranges) }}</td>-->
            <td width="15%" >{{ props.item.email }}</td>
            <td width="10%" >{{ fncGetLocalizedDateFromUTC ( props.item.created_on ) }}</td>
            <td width="10%" v-if="objAuthorize.privileges.indexOf('VENDOR_MODULE') !== -1" >
              <a v-if="isLoading == false" @click.prevent="fncShowEdit(props.item, props.item.name)"><i class="material-icons">edit</i></a>
              <img v-if="isLoading == true" src="../shared/assets/images/ajax.gif" />
            </td>
            <td width="10%" v-if="objAuthorize.privileges.indexOf('VENDOR_MODULE') !== -1" ><a @click.prevent="fncDeleteVendor(props.item.id, props.item.name)"><i class="material-icons">delete</i></a></td>
          </template>
        </v-data-table>
      </v-container>
    </v-content>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex';

  export default {
	name: 'RoleList',
	intRoleEdit: 0,
    data () {
		return {
			search: '',
            headers: [
              { text: 'NAME', value: 'name', width: '30%' },
              { text: 'VENDOR CODE', value: 'description', width: '25%' },
              { text: 'EMAIL', value: 'email', width: '15%' },
              { text: 'CREATED ON', value: 'created_on', width: '10%' },
              { text: 'EDIT', value: 'edit', width: '10%' },
              { text: 'DELETE', value: 'delete', width: '10%' }
            ]
		}
	},
    methods: {
      fncGetLocalizedDateFromUTC ( theDate ) {

        var options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "numeric",
          minute: "numeric",
          hour12: false
        };

        var newDate = new Date( Date.parse(theDate + ' UTC') );
        var dateString = newDate.toLocaleString("en", options);
        var objDate = dateString.split(',');

        var newDate = objDate[0].split('/');

        var strDate = newDate[2] + '-' + newDate[0] + '-' + newDate[1] + ' ' + objDate[1];

        return strDate;

      },
      fncClearSearch() {
        this.search = '';
      },
      fncShowRanges(ranges) {
        var rangeReturn = '';
        for (var r in ranges) {
          rangeReturn += ranges[r].manufacturer_name + ' - ' + ranges[r].range_name + '<br />';
        }
        return rangeReturn;
      },
      fncShowEdit(vendor, vendorName) {
        this.$store.dispatch({
          type: 'fncSetVendorEdit',
          vendor: vendor,
          vendor_name: vendorName
        })
        this.$store.commit('setIsLoading', true);
		},
      fncDeleteVendor (vendorId, vendorName) {
			var confirmDelete = confirm('Are you sure you would like to remove '+vendorName+'?');
			if( confirmDelete === true ) {
				this.$store.dispatch({
					type: 'fncVendorDelete',
					vendorId: vendorId
				});
			}
		}
	},
	computed: {
		...mapGetters([
			'userRoles',
			'objVendorEdit',
			'objAuthorize',
            'vendorList',
            'isLoading'
		])
	},
	beforeMount() {
		this.$store.dispatch('fncPopulateVendors');
	}
}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
